
export default {
  name: 'ErrorPage',
  layout: 'minimal',
}
